import SupportListWrapper from 'core/page/SupportListWrapper'
import { listCustomers, updateAppId, updateOuName } from '../../state/actions'
import { useHistory, useParams } from 'react-router-dom'
import { CustomerInterface } from '@cbgms/api/modules/customers'
import { useSearchCustomers } from '../../hooks/use-search-customers'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import { Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { IRootReducerState } from 'state/reducers'
import store from '../../state/store'
import { v4 as uuidv4 } from 'uuid'

export const CustomersList: () => JSX.Element = () => {
  const [seed, setSeed] = useState<string>(uuidv4())
  const handleReload = () => {
    setSeed(uuidv4())
  }
  const { getSearchComponent, apiSearchQuery } = useSearchCustomers({ handleReload })
  const { t } = useTranslation()
  const [inactiveCustomerWarning, setInactiveCustomerWarning] = useState(false)
  const history = useHistory()
  const isFormSuccess = useParams<{ isFormSuccess: string }>().isFormSuccess
  const operatingunit = useSelector((state: IRootReducerState) => state.auth.user['ou_name'])
  const appid = useSelector((state: IRootReducerState) => state.auth.user['AppId'])
  store.dispatch(updateAppId(String(appid)))
  store.dispatch(updateOuName(String(operatingunit)))

  const onEdit = (data: { Customer: CustomerInterface }) => {
    if (data.Customer.CustStatus === 'Inactive') {
      setInactiveCustomerWarning(true)
      setTimeout(() => {
        setInactiveCustomerWarning(false)
      }, 4000)
      return null
    }
    history.push(`/LKQ/OfferPackage/${data.Customer.CustEosID}`)
  }
  if (isFormSuccess) {
    setTimeout(() => {
      history.push('/LKQ/OfferPackage')
    }, 5000)
  }

  return (
    <>
      <Typography variant='h6' style={{ marginBottom: '16px', fontSize: 20, fontWeight: 700 }}>
        {t('Customers.CustomerListTitle')}
      </Typography>{' '}
      {isFormSuccess && <div className='ui message success'>{t('Customers.orderSuccessful')}</div>}
      {inactiveCustomerWarning && <div className='ui message warning'>{t('Customers.InActiveCustomer')}</div>}
      <SupportListWrapper
        key={seed}
        scope='customers-offerPackage'
        loadAction={listCustomers}
        onEdit={onEdit}
        middleMenuItems={getSearchComponent}
        translationKey='customers'
        predefinedSearch={apiSearchQuery}
        hideExport
        noDataPlaceholder={t('Customers.NoCustomerFound')}
      />
    </>
  )
}

export default CustomersList
